module.exports = __webpack_public_path__ + "img/all.1387f04f.svg";